// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"ViewSliderPcContainerType_modal-scroll__UzlV0","slider-container":"ViewSliderPcContainerType_slider-container__q1rmA"};